module.exports = __webpack_public_path__ + "img/photoAlbum3.47b03046.jpg";